import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "summaryTab", "detailedTab",
    "summaryContent", "detailedContent"
  ]

  connect() {
    console.log("SummaryTabsController connected")
  }

  showTab(event) {
    event.preventDefault()
    const tab = event.currentTarget.dataset.tab
    
    if (!this.hasSummaryTabTarget || !this.hasDetailedTabTarget) {
      console.error("SummaryTabs: Missing tab button targets")
      return
    }
    
    if (!this.hasSummaryContentTarget || !this.hasDetailedContentTarget) {
      console.error("SummaryTabs: Missing content targets")
      return
    }
    
    if (tab === "summary") {
      this.summaryTabTarget.classList.add("border-blue-500", "text-blue-600")
      this.summaryTabTarget.classList.remove("border-transparent", "text-slate-500")
      this.detailedTabTarget.classList.remove("border-blue-500", "text-blue-600")
      this.detailedTabTarget.classList.add("border-transparent", "text-slate-500")
      
      this.summaryContentTarget.classList.remove("hidden")
      this.detailedContentTarget.classList.add("hidden")
    } else if (tab === "detailed") {
      this.detailedTabTarget.classList.add("border-blue-500", "text-blue-600")
      this.detailedTabTarget.classList.remove("border-transparent", "text-slate-500")
      this.summaryTabTarget.classList.remove("border-blue-500", "text-blue-600")
      this.summaryTabTarget.classList.add("border-transparent", "text-slate-500")
      
      this.detailedContentTarget.classList.remove("hidden")
      this.summaryContentTarget.classList.add("hidden")
    }
  }
}
